import { Controller } from "@hotwired/stimulus"

// POS 상품 수량을 넘패드로 입력하는 모달 컨트롤러
export default class extends Controller {
  static targets = ["display", "total"]
  static values = { posItemId: Number, orderInfoId: Number, salePrice: Number, code: String }

  connect() {
    this.value = this.displayTarget.textContent.trim() || "0"
    this.isFirstPress = true
    this.updateDisplay()
  }

  press(event) {
    const key = event.currentTarget.dataset.key
    if (this.isFirstPress) {
      this.value = key === "00" ? "0" : key
      this.isFirstPress = false
    } else if (this.value === "0") {
      this.value = key === "00" ? "0" : key
    } else if (this.value.length < 6) {
      this.value += key
    }
    this.updateDisplay()
  }

  clear() {
    this.value = "0"
    this.isFirstPress = false
    this.updateDisplay()
  }

  quickAmount(event) {
    this.value = event.currentTarget.dataset.amount.toString()
    this.isFirstPress = false
    this.updateDisplay()
  }

  updateDisplay() {
    const count = parseInt(this.value || "0")
    this.displayTarget.textContent = count.toLocaleString()
    if (this.hasTotalTarget) {
      const total = count * this.salePriceValue
      this.totalTarget.textContent = total.toLocaleString()
    }
  }

  async confirm() {
    const count = parseInt(this.value || "0")

    const posEl = document.querySelector('[data-controller~="pos"]')
    const posController = posEl && this.application.getControllerForElementAndIdentifier(posEl, 'pos')

    if (!posController) return

    let actionName = null
    let payload = null

    if (this.hasOrderInfoIdValue && this.orderInfoIdValue) {
      actionName = "cart_set_barcode_item_count"
      payload = {
        order_info_id: this.orderInfoIdValue,
        count:         count
      }
    } else if (this.hasPosItemIdValue && this.posItemIdValue) {
      actionName = "cart_set_item_count"
      payload = {
        pos_item_id: this.posItemIdValue,
        code:        this.codeValue || undefined,
        count:       count
      }
    }

    if (!actionName) return

    try {
      await posController.cartAction(actionName, payload)
    } catch (e) {
      console.error(`${actionName} failed:`, e)
      alert("서버 통신 오류입니다. 다시 시도해주세요.")
      return
    }

    const modalsFrame = document.querySelector('turbo-frame[id="modals"]')
    if (modalsFrame) modalsFrame.innerHTML = ""
  }
}
